var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToutiaoProject',{attrs:{"sub-media-id":3}})
}
var staticRenderFns = []

export { render, staticRenderFns }